"use client";

import { useState, useCallback } from 'react';
import { trackEvent } from '@/lib/analytics';

interface UseContactModalReturn {
  isContactModalOpen: boolean;
  openContactModal: (source?: string) => void;
  closeContactModal: () => void;
}

export const useContactModal = (): UseContactModalReturn => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openContactModal = useCallback((source: string = 'unknown') => {
    setIsContactModalOpen(true);
    
    // Track the opening action
    trackEvent('contact_modal_requested', {
      source,
      timestamp: new Date().toISOString(),
      page: typeof window !== 'undefined' ? window.location.pathname : 'unknown'
    });
  }, []);

  const closeContactModal = useCallback(() => {
    setIsContactModalOpen(false);
  }, []);

  return {
    isContactModalOpen,
    openContactModal,
    closeContactModal,
  };
};
